/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type AccommodationBookingObjectContentResponseModelContentType = typeof AccommodationBookingObjectContentResponseModelContentType[keyof typeof AccommodationBookingObjectContentResponseModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccommodationBookingObjectContentResponseModelContentType = {
  accommodationBookingObject: 'accommodationBookingObject',
} as const;
